jQuery(document).ready(function($) {
    var urlParams = new URLSearchParams(window.location.search);
    var tabParam = urlParams.get('tab');

    function updateUrlParam(tabId) {
        var newParams = new URLSearchParams(window.location.search);
        newParams.set('tab', tabId);
        var newUrl = window.location.pathname + '?' + newParams.toString();
        window.history.replaceState({}, '', newUrl);
    }

    $('.tabs-js').each(function(){
        var $tabs = $(this);
        $tabs.find('.tabs__panel').hide();

        if (tabParam && $tabs.find('#' + tabParam).length) {
            $tabs.find('#' + tabParam).show().addClass('tab-open');
            $tabs.find('[data-tab="#' + tabParam + '"]').addClass('active');
        } else {
            $tabs.find('.tabs__panel:first').show().addClass('tab-open');
            $tabs.find('[data-tab]:first').addClass('active');
        }
    });

    $('[data-tab]').click(function() {
        $(this).closest('.tabs-js').find('[data-tab]').removeClass('active');
        $(this).addClass('active');
        $(this).closest('.tabs-js').find('.tabs__panel').hide().removeClass('tab-open');

        var selectTab = $(this).attr('data-tab');
        $(selectTab).fadeIn().addClass('tab-open');
        updateUrlParam(selectTab.replace('#', ''));
    });

    $('.tabs__select').on('change', function() {
        $('.tabs__panel').hide();

        var selectTab = $(this).val();

        $(selectTab).fadeIn();
    });

    // Toggle dropdown open/close
    $('#tabs-dropdown').click(function(e) {
        e.stopPropagation();
        $(this).toggleClass('is-toggled');
    });

    // Handle dropdown item clicks
    $('#tabs-dropdown [data-tab]').click(function(e) {
        e.preventDefault();
        e.stopPropagation();

        var selectTab = $(this).attr('data-tab');
        var selectText = $(this).text();
        $('.tab-content').removeClass('tab-open').hide();

        $(selectTab).fadeIn().addClass('tab-open');
        $('#tabs-dropdown .selected-text').text(selectText);
        updateUrlParam(selectTab.replace('#', ''));

        $('#tabs-dropdown').removeClass('is-toggled');
    });

    // Close dropdown when clicking outside
    $(document).click(function() {
        $('#tabs-dropdown').removeClass('is-toggled');
    });
});
